export default {"src":"/_next/static/media/convenience.e0db1253.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};